module.exports = __webpack_public_path__ + "static/media/advisor_joins.f8734d1e.png";